import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
import axios from 'axios'
import qs from 'qs'
import apis from './apis'


// 环境的切换
if (process.env.NODE_ENV == 'development') {
    console.log('测试环境')    
    console.log(apis.baseURL);
    axios.defaults.baseURL = apis.baseURL;
} else if (process.env.NODE_ENV == 'debug') {    
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {    
    console.log('生产环境')
    axios.defaults.baseURL = apis.productionBaseUrl;
}

axios.defaults.withCredentials = true;
// axios.defaults.baseURL = apis.baseURL;

// axios.defaults.headers.post['Content-Type'] = 'application/json';
//location.hostname == 'mc.fashvn.com'?'https://mc.fashvn.com/pc/api':'https://mc1.fashvn.com/pc/api',
var instance = axios.create({
    baseURL: apis.baseURL,
    timeout: 120000,
});

instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    if(config.method === 'post') {
        config.data = qs.stringify(config.data);
      } 
    //console.log(config);
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
//添加拦截器
instance.interceptors.response.use(res => {
    // 对响应数据做点什么
    if (res.data.msg == "not_found_user_id") {
        MessageBox.confirm('账号登录停留时间过长,请重新登录!', '提示', {
                confirmButtonText: '确定',
                showCancelButton : false ,
                type: 'warning'
            }).then(() => {
                //跳转login页面
                sessionStorage.removeItem("Token");
                sessionStorage.removeItem("treeId");
                window.location.href = `https://vms.fashvn.com/#/login`;
            }).catch(() => {
                    Message({
                        message: '已取消'
                    })        
            });
        return ;
    }
    if(res.data.code == 500){
        MessageBox.confirm('数据请求失败，请刷新重试!', '提示', {
            confirmButtonText: '确定',
            showCancelButton : false ,
            type: 'warning'
          }).then(() => {
                
          }).catch(() => {
                Message({
                    message: '已取消'
                })        
        });
        return ;
    }
    return res;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance
// export { apis }

